/**
 * This file was initially generated by scripts/createStrapiComponent/create-strapi-component.js.
 * Feel free to modify it as needed.
 */
import { collectImageComponentParams } from '../shared/collector';

import { BackgroundRemoverStrapi } from './types';

export const collectBackgroundRemoverComponentParams = (
  data: BackgroundRemoverStrapi
) => {
  return {
    background: collectImageComponentParams(data.background),
    title: data.title,
    subline: data.subline,
  };
};
